export const cssTemplate = `<style type="text/css">
    .server-theme .bg-primary {
      background-color: $primary;
    }
    
    .server-theme .primary-color {
      color: $primary;
    }
    
    .server-theme .primary-light-color {
      color: $primary-light;
    }
    
    .server-theme .bg-primary-light {
      background-color: $primary-light;
    }
    
    .server-theme .secondary-color {
      color: $secondary;
    }
    
    .server-theme .bg-secondary {
      background-color: $secondary;
    }
    
    .server-theme .primary-border {
      border: 1px solid $primary;
    }
    
    .server-theme .secondary-border {
      border: 1px solid $secondary;
    }
    
    .server-theme .btn-outline-primary {
      border-color: $primary;
      color: $primary;
    }
    
    .server-theme .btn-outline-primary:hover {
      color: #fff !important;
      background-color: $primary;
    }
    
    .server-theme .btn-outline-primary:not(:disabled):not(.disabled).active {
      border-color: $primary;
      background-color: $primary;
      color: #fff !important;
    }
    
    .server-theme .bg-secondary-light {
      background-color: $secondary-light;
    }
    
    .server-theme .btn-primary {
      background-color: $primary;
      border-color: $primary;
    }
    
    .server-theme .btn-secondary {
      background-color: $secondary;
      border-color: $secondary;
    }
    
    .server-theme .home-page-card:hover {
      background-color: $primary-light;
      color: $primary;
    }
    
    .server-theme .svg-secondary {
      fill: $secondary;
    }
    
    .server-theme .skill-checklist input[type='radio'].proficiency:checked+span {
      background: $primary;
      border-color: $primary;
      color: white !important;
    }
    
    .server-theme .skill-checklist input[type='radio'].frequency:checked+span {
      background: $secondary;
      border-color: $secondary;
      color: white !important;
    }
    
    .server-theme .vue-treeselect__checkbox--checked {
      border-color: $primary;
      background: $primary;
    }
    
    .server-theme .vue-treeselect__label-container:hover .vue-treeselect__checkbox--unchecked {
      border-color: $primary;
    }
    
    .server-theme .vue-treeselect__multi-value-item {
      color: $primary;
      background: $primary-light;
    }
    
    .server-theme .vue-treeselect__value-remove {
      color: $primary;
    }
    
    .server-theme .router-link-active.my-profile-tab {
      background-color: $primary;
    }
    
    .server-theme .my-profile-tab:hover {
      background-color: $primary;
    }
    
    .server-theme .my-referrals-list-container .my-referral-tab a.nav-link.active {
      border-color: $primary;
      color: $primary;
    }
    
    .server-theme .app-header .left-menu-options.router-link-active span {
      color: $primary;
    }
    
    .server-theme .app-header .menu-item.router-link-active {
      border-left: 6px solid $primary;
      color: $primary;
    }
    
    .server-theme .app-sidemenu .menu-item:hover {
      border-left: 6px solid $primary;
    }
    
    .server-theme .app-sidemenu .menu-item:hover .menu-text {
      color: $primary;
    }
    
    .server-theme .app-sidemenu .menu-item.router-link-active {
      border-left: 6px solid $primary;
      color: $primary;
    }
    
    .server-theme .fill-color-rating input[type='radio']:after {
      border: 2px solid $primary;
    }
    
    .server-theme .fill-color-rating input[type='radio']:checked:after {
      background-color: $primary;
      border: 1px solid $primary;
    }
    
    .server-theme .myjobstatus .menu-item:hover {
      background-color: $primary;
    }
    
    .server-theme .myjobstatus .menu-item.active {
      border: 1px solid $primary;
      background-color: $primary;
    }
    
    .server-theme .nav-pills .active {
      color: $primary;
      border-bottom: 3px solid $primary;
    }
    
    .server-theme .skill-dropdown button {
      color: $primary;
    }
    
    .server-theme .ui.label {
      background-color: $primary;
    }
    
    .server-theme .pagination .page-item .page-link:focus,
    .server-theme .page-link:hover {
      background-color: $primary;
    }
    
    .server-theme .multiselect__option--highlight {
      background: $primary;
    }
    
    .server-theme .multiselect__option--highlight:after {
      background: $primary;
    }
    
    .server-theme .multiselect__tag {
      background: $primary;
      color: #fff;
    }
    
    .server-theme .multiselect__tag-icon:hover {
      background: $primary;
    }
    
    .server-theme #MyJobsAdminCommentsSection span {
      color: $primary;
      background-color: $primary-light;
    }
    
    .server-theme .svg-primary {
      fill: $primary;
    }
    
    .server-theme input:focus+.slider {
      box-shadow: 0 0 1px $primary;
    }
    
    .server-theme input:checked+.sliderEdit {
      background-color: $primary;
    }
    
    .server-theme input:focus+.sliderEdit {
      box-shadow: 0 0 1px $primary;
    }
    
    .server-theme input:checked+.slider {
      background-color: $primary;
    }
    
    .server-theme .skill-dropdown button {
      color: $primary;
    }
    
    .server-theme a {
      color: $primary;
    }
    
</style>`;
